module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAXCAYAAADgKtSgAAABCklEQVRIS+3VMU/CQBjG8f9r2rOrn4XZBHdXWdm4Di5+AmEAEiY3U/0CrMwMzix0wo2li5OrJpVwxoaaJkDLwTGQ0LHJ/Z4n73vJCUf8ZM1+Sd+yfy11w2taYym3fHhd2rKw7VGORz+PYNpAjFwMaHlDm4Bd8ZVphgTqnqZ87hJiiWfkF8gA7XeqAvbBczOG5R06mG8LOQTPzSe0etgU4AJfjYprtJoWQ1zhf+YM4zcI5T0PcIVH4PfQkrhsPsGYPuHlyOXMU5AeV16fhqTubovIKGur1cThPTdJ1larqAq1XejGhVWFlN+W5+86Ij5hMK6C7Be6j1g4U978jP9PoPjMndZYDmxbPP4Lus6eGBH9eScAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/maptool/draw/sjq.png
// module id = LLvq
// module chunks = 36